import React from "react"
import { AboutThisExpenseUploadFile } from "./UploadFile"
import { Progress } from "../../views/modal/Progress"
import FileCategories from "../../../utils/FileCategories"
import { Stack, Text } from "@carrotfertility/carotene"
import { Link } from "@carrotfertility/carotene-core"
import { Body } from "../../views/atoms/Bodies"
import { FormattedMessage, useIntl } from "react-intl"

export const UploadDoulaDocumentation = (): JSX.Element => {
  const intl = useIntl()
  const fileCategory = FileCategories.DOULA
  const uploadHeader = intl.formatMessage({ defaultMessage: "Upload attestation form" })

  const UploadDoulaDocumentationBody = () => {
    return (
      <Stack spacing="medium">
        <Body color="black-80">
          <Text>
            <FormattedMessage
              defaultMessage="Please upload the completed <link>attestation form</link> to confirm that your doula meets our qualifications."
              values={{
                link: (linkContent) => (
                  <Link target="_blank" href="/your-benefit-guide/coverage/pregnancy-and-postpartum" color="inherit">
                    {linkContent}
                  </Link>
                )
              }}
            />
          </Text>
        </Body>

        <Text>
          <FormattedMessage defaultMessage="We can accept jpg, jpeg, png, pdf, HEIC, doc, docx, txt, xlsx, and zip files up to 30 MB." />
        </Text>
      </Stack>
    )
  }
  const progress = (
    <Progress
      numSteps={3}
      step={2}
      label={intl.formatMessage({ defaultMessage: "About This Expense" })}
      inactiveStepBackgroundColor="#DBE6EE"
    />
  )

  return (
    <>
      <AboutThisExpenseUploadFile
        fileCategory={fileCategory}
        progress={progress}
        uploadHeader={uploadHeader}
        body={<UploadDoulaDocumentationBody />}
      />
    </>
  )
}
